@use "@fukuri-admins/ui/layout" as *;

.Root {
  &__Title {
    text-align: center;
    font-weight: 400;
    margin-bottom: 8px;
    font-size: 32px;
  }
  &__Description {
    font-size: 14px;
    color: $TextLabel;
    text-align: center;
  }
  .menuContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    margin-bottom: 32px;
    .outputCsv {
      cursor: pointer;
      padding: 8px 16px;
      border-radius: 6px;
      background-color: $Button;
      color: $White;
      display: flex;
      align-items: center;
      font-weight: bold;
      gap: 4px;
      font-size: 16px;
      transition: background-color 0.2s ease-out;
      &:hover {
        background-color: $ButtonHover;
      }
    }
  }
  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .tableWrapper {
    margin-bottom: 16px;
  }
}
